export default "__VITE_ASSET__BDkKgOUy__"